<template>
  <div>
    <select v-model.number="selectedId">
      <option value="">-- 스페셜 선택 --</option>
      <option
        v-for="special in specialList"
        :key="special.id"
        :value="special.id"
      >
        {{ special.title }} ({{ special.uuid }})
      </option>
    </select>

    <a
      v-show="selectedId"
      :href="`https://article21.kr/article/special/${selectedSpecial?.uuid}`"
      target="_blank"
      style="display: inline-block; margin-top: 4px;"
    >
      스페셜 보기
    </a>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, defineProps, defineEmits } from 'vue';
import { apiClient } from '@/services/auth-header';

const specialList = ref([]);

const props = defineProps({
  contentId: { type: [String, Number], default: '' },
});
const emit = defineEmits(['update:contentId']);

const selectedId = computed({
  get: () => props.contentId,
  set: (value) => emit('update:contentId', value),
});

const selectedSpecial = computed(() => {
  return specialList.value.find(special => special.id === selectedId.value);
});

const fetchSpecialList = async () => {
  try {
    const response = await apiClient.get('/contents/articles/specials');
    specialList.value = response.data;
  } catch (error) {
    console.error('스페셜 목록 조회 실패:', error);
  }
};

onMounted(() => {
  fetchSpecialList();
});
</script>

<style scoped>
select {
  width: 100%;
  padding: 8px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 14px;
  cursor: pointer;
}
</style>
